// a pending onDebounce call doesn't fire once its listener is gone from the object:
// from every plain, DOM and delegated event of it
export default function cancelIfGone(allEvents, callback) {
  for (var name in allEvents) {
    if (allEvents[name].some(function (_ref) {
      var _info$domEvent, _info$delegatedData;
      var existing = _ref.callback,
        info = _ref.info;
      return existing === callback || ((_info$domEvent = info.domEvent) == null ? void 0 : _info$domEvent.callback) === callback || ((_info$delegatedData = info.delegatedData) == null ? void 0 : _info$delegatedData.callback) === callback;
    })) {
      return;
    }
  }
  callback.cancel == null || callback.cancel();
}